import { Grid, Box, Typography } from "@mui/material";
import RecoverForm from "../../components/Auth/RecoverForm";

const RecoverPage = () => {
    return (<>

        <Box
            sx={{
                backgroundColor: 'background.paper',
                justifyContent: 'center',
                margin: 'auto',
                marginTop: '3rem',
                marginBottom: '3rem',
                maxWidth: '30rem',

            }}

        >

            <Grid container justifyContent={'center'} p={3}>
                <Box>
                    <Typography component="h2" sx={{
                        fontSize: '1.5rem',
                        lineHeight: '1.5',
                        fontFamily: '"DM Sans", sans-serif',
                        fontWeight: 700,
                        margin: 0,
                        textAlign: 'center',
                        maxWidth: '25rem',
                    }}>
                        Recuperar Cuenta
                    </Typography>
                    <Typography component="h6" sx={{
                        fontSize: '1rem',
                        lineHeight: '1.5',
                        fontFamily: '"DM Sans", sans-serif',
                        fontWeight: 400,
                        margin: 0,
                        textAlign: 'center',
                    }}>
                    </Typography>

                    <RecoverForm />
                </Box>
            </Grid>
        </Box>



    </>);
}

export default RecoverPage;